import React from "react";

import { useTranslation } from "react-i18next";

export const NoResults = () => {
    const { t } = useTranslation();

    return <div className="no-search-results">{t("No search results")}</div>;
};
